import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import Image from "next/image";
import PaypalIcon from "public/images/paypal-icon.svg";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Radio,
  RadioGroup,
  Spinner,
  Text,
  Tooltip,
  useDimensions,
  useMediaQuery,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from "@chakra-ui/react";
import { Network } from "@models/network";
import { User } from "@models/user";
import { walletAddressPreview } from "@models/utils";
import { Wallet } from "@models/wallet";
import { useUserStore } from "@providers/auth";
import Dialog from "components/Dialog/Dialog";
import { SelectTicketModalItem } from "components/TicketingModal/SelectTicketModal";
import { ModalItemProps } from "components/TicketingModal/TicketingModal";
import { useAtom } from "jotai";
import { groupBy } from "lodash";
import { useTranslations } from "next-intl";
import RedCrossIcon from "public/images/ic-blurred-bg-filled-red-cross.svg";
import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { markDiscount } from "services/discount";
import { sendEmailForTransaction } from "services/email";
import { mintNFT } from "services/nft";
import { markTicket } from "services/ticket";
import { createTransaction, getTransactionByEmail } from "services/transaction";
import {
  checkoutFormLoadingAtom,
  languageAtom,
  openPaymentErrorModalAtom,
  selectedTicketAtom,
  successAtom,
} from "utils/atoms";
import {
  PaypalTransaction,
  PaypalTransactionCaptureStatus,
} from "utils/mongo/transactions.model";
import { v4 as uuid } from "uuid";
import ContactInformation from "./ContactInformation";
import TicketingModalExpandableButton from "components/TicketingModal/TicketingModalExpandableButton";
import PayPalButtonWrapper from "components/PayPalButtonWrapper/PayPalButtonWrapper";

const FOLLOW_TWITTER_LINK =
  "https://twitter.com/intent/follow?original_referer=https%3A%2F%2Fwww.moongate.id%2F&ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Efollow%7Ctwgr%5E0xmoongate&screen_name=0xmoongate";

const WalletGroup = ({ walletGroup }: { walletGroup: Wallet[] }) => {
  const networks = walletGroup
    .map((w) => w.network)
    .sort((a, b) => (a == Network.ETHEREUM ? -1 : 1 || a < b));
  const wallet = walletGroup[0];
  const address = wallet.address;
  return (
    <Radio value={address} borderColor="grey" border="solid" colorScheme="teal">
      <div className="flex flex-row items-center">
        <div>
          <div
            className="cursor-pointer"
            onClick={() => navigator.clipboard.writeText(address)}
          >
            <Tooltip label={address}>{walletAddressPreview(address)}</Tooltip>
          </div>
        </div>
        {/*
        <Text>
          &nbsp;
          {"("}
          {networks.join(", ")}
          {")"}
        </Text>
        */}
        {/*networks.map((network, i) => (
        <NetworkIcon key={i} network={network} />
      ))*/}
      </div>
    </Radio>
  );
};

export const CheckoutModalItem: ModalItemProps = {
  title: () => <CheckoutModalTitle />,
  backButton: (setModalItem: (modalItem: ModalItemProps) => void) =>
    setModalItem(SelectTicketModalItem),
  children: () => <CheckoutModalContent />,
  //  actionButton: () => <CheckoutModalActionButton />,
};

const CheckoutModalTitle = () => {
  const t = useTranslations("index");
  const [checkoutFormLoading] = useAtom(checkoutFormLoadingAtom);
  return (
    <div className=" flex flex-row justify-between items-center mr-auto flex-grow ">
      <Text className="my-1" fontSize="2xl">
        {t("checkout")}
      </Text>
      {checkoutFormLoading && <Spinner />}
    </div>
  );
};

//const CheckoutModalActionButton = () => {
//  return (
//    <></>
//  );
//};
//
// paypal, credit card, crypto
const PaymentMethods = [
  {
    name: "PayPal",
    active: true,
  },
  {
    name: "Credit Card",
    active: false,
  },
  {
    name: "Crypto",
    active: false,
  },
];

const CheckoutModalContent = () => {
  const [openDialog, setOpenDialog] = useAtom(openPaymentErrorModalAtom);
  const [customId] = useState(uuid());
  const [invoiceId] = useState(uuid());
  const elementRef = useRef(null);
  const twitterLinkRef = useRef(null);
  const dimensions = useDimensions(elementRef, true);
  const [, setSuccess] = useAtom(successAtom);
  const user = useUserStore((state) => state.user);
  const [userEmailFirstTime, setUserEmailFirstTime] = useState(false);
  const [claiming, setClaiming] = useState(false);
  const t = useTranslations("checkout");
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const size = isMobile ? "full" : "md";
  const [selectedTicket] = useAtom(selectedTicketAtom);
  const [lang] = useAtom(languageAtom);
  const [, setCheckoutFormLoading] = useAtom(checkoutFormLoadingAtom);
  const [isFollowed, setIsFollowed] = useState(false);

  const wallets: Wallet[] = useMemo(() => {
    console.log(user);
    return user?.getWalletsByNetwork(Network.EVM) || [];
  }, [user]);

  const walletGroups = useMemo(
    () => groupBy(wallets, (wallet: Wallet) => wallet.address) || {},
    [wallets]
  );

  const { register, formState, watch, setValue, trigger, control, getValues } =
    useForm<{
      [key: string]: string;
    }>({
      //mode: "onChange",
    });

  const { isValid, errors, isValidating } = formState;

  useEffect(() => {
    setCheckoutFormLoading(isValidating);
  }, [formState]);

  useEffect(() => {
    const prefillEmailAddress = async (user: User) => {
      const transactions = await getTransactionByEmail(user.email);
      const isFirstTime = transactions.length === 0;
      setUserEmailFirstTime(isFirstTime);
      if (isFirstTime) {
        setValue("0-emailAddress", user.email);
        setValue("0-confirmEmailAddress", user.email);
      }
    };
    if (user && user.email) {
      prefillEmailAddress(user);
    }
  }, [user]);

  const handleDeveloperClick = async () => {
    if (!selectedTicket || !user) return;
    setClaiming(true);
    const recipient = getValues("walletAddress") || "";
    const [created, transaction] = await createTransaction(
      PaypalTransactionCaptureStatus.WAIVED,
      watch(),
      customId,
      invoiceId,
      selectedTicket,
      user,
      lang
    );
    if (created) {
      try {
        const _transaction = new PaypalTransaction(transaction);

        // mark discount code as used
        if (selectedTicket.discount)
          await markDiscount(
            selectedTicket.discount.id,
            selectedTicket.quantity
          );
        // update ticket count
        await markTicket(selectedTicket.ticket, selectedTicket.quantity);

        mintNFT(recipient, _transaction);
        await sendEmailForTransaction(_transaction);
        setSuccess(true);
      } catch (e) {
        console.error(e);
      } finally {
        setClaiming(false);
      }
    } else {
      console.error("error while creating transaction");
      setOpenDialog(true);
      setClaiming(false);
    }
  };

  const beforeCreateOrder = async () => {
    if (!selectedTicket || !user) return;
    const [created] = await createTransaction(
      PaypalTransactionCaptureStatus.INITIATED,
      watch(),
      customId,
      invoiceId,
      selectedTicket,
      user,
      lang
    );
    return created;
  };

  if (!selectedTicket) {
    return <>Loading...</>;
  }

  const handleFollowClick = () => {
    setIsFollowed(true);
  };

  const handleFollowCheckboxChange = (e) => {
    if (twitterLinkRef.current) {
      e.preventDefault();
      (twitterLinkRef?.current as any).click();
      setIsFollowed(true);
    }
  };

  //let inputFile: any;

  return (
    <>
      <div className="flex p-4 md:p-12 gap-6 flex-col overflow-y-scroll w-full h-full bg-neutral-850">
        <div>
          <Text fontSize="2xl" fontWeight={500} my={"2rem"}>
            {t("contactInformation")}
          </Text>
          <Text
            fontSize="md"
            fontWeight={500}
            my={"2rem"}
            color={"neutral.200"}
          >
            Please fill out the form below to claim your NFT.
          </Text>

          <Accordion defaultIndex={[0]} allowMultiple>
            {[...Array(selectedTicket.quantity)].map((_, index, { length }) => (
              <ContactInformation
                key={index}
                attendee={index}
                register={register}
                errors={errors}
                selectedTicketType={selectedTicket.ticket.id}
                //validateEmail={validateEmail}
                watch={watch}
                isLast={index === length - 1}
                userEmailFirstTime={userEmailFirstTime}
                user={user}
                trigger={trigger}
              />
            ))}
          </Accordion>
        </div>

        {/* Airdrop Select Wallet */}
        {userEmailFirstTime && (
          <>
            <div>
              <Text fontSize="2xl" fontWeight={500} mt={"2rem"}>
                Receiving Wallet
              </Text>
              {/* subTitle */}
              <Text
                fontSize="md"
                fontWeight={500}
                mt="1rem"
                color={"neutral.200"}
              >
                Please select a wallet that will be receiving the ticket NFT.
              </Text>
            </div>

            <div className="px-1 ">
              {walletGroups && (
                <Controller
                  name="walletAddress"
                  control={control}
                  rules={{ required: true }}
                  defaultValue={wallets[0]?.address}
                  render={({ field: { onChange, value } }) => (
                    <RadioGroup
                      onChange={onChange}
                      value={value}
                      display="flex"
                      flexDir="column"
                      gap="1rem"
                    >
                      {Object.values(walletGroups).map((walletGroup, i) => (
                        <WalletGroup key={i} walletGroup={walletGroup} />
                      ))}
                    </RadioGroup>
                  )}
                />
              )}
            </div>
          </>
        )}

        <div>
          <div>
            <Text fontSize="2xl" fontWeight={500} mt={"2rem"}>
              Acknowledgements
            </Text>

            <Text
              fontSize="md"
              fontWeight={500}
              my="1rem"
              color={"neutral.200"}
            >
              Please read and acknowledge the following:
            </Text>
          </div>

          <div>
            <FormControl>
              <FormLabel htmlFor={"followTwitter"} variant="custom"></FormLabel>
              <div className="flex flex-row items-center ">
                <Checkbox
                  type={"checkbox"}
                  isChecked={isFollowed}
                  borderColor={"neutral.200"}
                  colorScheme="teal"
                  onChange={handleFollowCheckboxChange}
                >
                  * Follow us on &nbsp;
                  <a
                    target="_blank"
                    href={FOLLOW_TWITTER_LINK}
                    rel="noopener noreferrer"
                    className="underline text-primary-300"
                    onClick={handleFollowClick}
                    ref={twitterLinkRef}
                  >
                    {"Twitter"}
                  </a>
                  &nbsp; to proceed. (Required)
                </Checkbox>
              </div>
            </FormControl>

            <FormControl isInvalid={Boolean(errors.agreement)}>
              <FormLabel htmlFor={"agreement"} variant="custom"></FormLabel>
              <Checkbox
                borderColor={"neutral.200"}
                colorScheme="teal"
                type={"checkbox"}
                //placeholder={placeholder}
                {...register("agreement", {
                  required: `This field is required`,
                  onChange: async () => {
                    await trigger("agreement");
                  },
                })}
              >
                {t.rich("termAndCondition", {
                  termAndCond: (children) => (
                    <a
                      target="_blank"
                      href="https://moongate.id/terms"
                      rel="noopener noreferrer"
                      className="underline text-primary-300"
                    >
                      {children}
                    </a>
                  ),
                  privacyPolicy: (children) => (
                    <a
                      target="_blank"
                      href="https://moongate.id/privacy"
                      rel="noopener noreferrer"
                      className="underline text-primary-300"
                    >
                      {children}
                    </a>
                  ),
                })}
              </Checkbox>
              <FormErrorMessage>{errors.agreement?.message}</FormErrorMessage>
            </FormControl>
          </div>
        </div>

        {selectedTicket.payable > 0 ? (
          <>
            <Text fontSize="2xl" fontWeight={500} mt={"2rem"}>
              {t("paymentMethod")}
            </Text>

            <Accordion defaultIndex={[0]}>
              {PaymentMethods.map((paymentMethod, index, { length }) => (
                <AccordionItem
                  isDisabled={!paymentMethod.active}
                  key={index}
                  borderTop={0}
                  _last={{ borderBottom: "0" }}
                >
                  <h2>
                    <AccordionButton
                      _hover={
                        {
                          //bg: "neutral.900",
                        }
                      }
                      bg="neutral.900"
                      px="1.25rem"
                      //borderTopRadius={!!attendee ? "" : "0.5rem"}
                      borderColor={"#DEDEE0"}
                      borderWidth="2px"
                      //borderColor={hasError ? "red.500" : "#DEDEE0"}
                    >
                      <Box
                        fontWeight={500}
                        fontSize="lg"
                        color="neutral.300"
                        flex="1"
                        textAlign="left"
                      >
                        <Text fontSize="2xl" fontWeight={500} my={"0.5rem"}>
                          {paymentMethod.name}
                        </Text>
                      </Box>
                      <AccordionIcon
                        width="2rem"
                        fontSize="2rem"
                        color="neutral.300"
                      />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel
                    borderWidth={"2px"}
                    borderColor={"#DEDEE0"}
                    borderTop={0}
                    px="1.25rem"
                    py="1rem"
                    borderBottomRadius={index == length - 1 ? "0.5rem" : ""}
                    borderBottomWidth={index == length - 1 ? "2px" : "0"}
                  >
                    {paymentMethod.name == "PayPal" && (
                      <>
                        <Text fontWeight={500} my={"0.875rem"}>
                          {t("paymentNote")}
                        </Text>
                        <PayPalButtonWrapper
                          disabled={!isValid}
                          items={selectedTicket.paypalItems}
                          amount={selectedTicket.paypalAmount}
                          customId={customId}
                          invoiceId={invoiceId}
                          beforeCreateOrder={beforeCreateOrder}
                        />
                      </>
                    )}
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>

            {/*
            <div className="grid grid-cols-1 gap-x-8 gap-y-8 my-8">
              <Menu>
                <MenuButton
                  ref={elementRef}
                  minH="4.813rem"
                  borderRadius="0.788rem"
                  border="3px solid"
                  borderColor="primary.200"
                  as={Button}
                  backgroundColor="neutral.850"
                  _active={{ background: "neutral.850" }}
                  _hover={{ background: "neutral.850" }}
                  _focus={{ background: "neutral.850" }}
                  rightIcon={<ChevronDownIcon w="32px" h="32px" />}
                  display="flex"
                  justifyContent="space-between"
                >
                  <div className="w-min flex flex-row items-center normal-case overflow-hidden">
                    <div className="w-10 mr-5">
                      <Image
                        layout="responsive"
                        src={PaypalIcon}
                        alt="paypal-icon"
                      />
                    </div>
                    <div className="w-full">{t("paymentMethodPaypal")}</div>
                  </div>
                </MenuButton>
                <MenuList
                  p={0}
                  minW={dimensions ? dimensions.borderBox.width : "md"}
                >
                  <MenuOptionGroup defaultValue={"paypal"} type="radio">
                    <MenuItemOption
                      value="paypal"
                      _checked={{ bg: "neutral.700" }}
                      flexDirection="row-reverse"
                      py="1.125rem"
                    >
                      <div className="w-min flex flex-row items-center">
                        <div className="w-10 mr-5">
                          <Image
                            layout="responsive"
                            src={PaypalIcon}
                            alt="paypal-icon"
                          />
                        </div>
                        PayPal
                      </div>
                    </MenuItemOption>
                  </MenuOptionGroup>
                </MenuList>
              </Menu>
            </div>
            */}
          </>
        ) : (
          <div className="my-8">
            <Button
              disabled={!isValid || claiming}
              onClick={handleDeveloperClick}
              isLoading={claiming}
              variant="gradient"
            >
              {" "}
              {t("claimTicket")}{" "}
            </Button>
          </div>
        )}
      </div>

      <Dialog
        isOpen={openDialog}
        size={size}
        onClose={() => setOpenDialog(false)}
        icon={RedCrossIcon}
        iconContainerStyles="w-24 mb-4"
        title={t("paymentErrorTitle")}
        titleStyles="text-2xl text-error font-semibold"
        minH="413px"
        contentJustifyContent="space-evenly"
        actions={[
          {
            text: t("tryAgain"),
            textColor: "text-neutral-100",
            primary: false,
            error: true,
            variant: "solid",
            bgColor: "error",
            onClick: () => {
              setOpenDialog(false);
            },
          },
        ]}
      >
        <div className="text-center text-white text-base font-medium ">
          {t("paymentErrorContent")}
        </div>
      </Dialog>

      <div className="md:hidden py-2 px-4 sm:p-4 flex flex-col w-full items-end bg-neutral-900 ">
        <div className="flex flex-row items-baseline">
          <div className="flex flex-col items-end">
            <TicketingModalExpandableButton />
          </div>
        </div>
      </div>

      {/*
      <div className="py-2 px-4 sm:p-4 flex flex-col w-full items-end bg-neutral-900 border-t-2 border-solid border-[black]">
        <div className="flex flex-row items-baseline">
          <div className="flex flex-col items-end">

            <div className="flex flex-row items-center transition-opacity duration-500">
              <div className="flex flex-col items-end py-1 sm:py-5">

                <Button
                  disabled={!isValid || claiming || !isFollowed}
                  fontSize="lg"
                  px="1.5rem"
                  py="0.70rem"
                  color="white"
                  fontWeight="bold"
                  borderRadius="6.25rem"
                  onClick={handleDeveloperClick}
                  rightIcon={<ArrowForwardIcon w="1.5rem" h="1.5rem" />}
                  isLoading={claiming}
                >
                  {"RSVP Now"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      */}
    </>
  );
};
